export default "__VITE_ASSET__5e37869f__"